// src/components/services/ServiceCard.jsx
import { Link } from 'react-router-dom';

const ServiceCard = ({ title, description, image, icon, link }) => {
  return (
    <div className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
      {/* Image */}
      <div className="relative h-64 md:h-72 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
        />
        
        {/* Overlay icon + title */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/60 to-transparent p-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full flex items-center justify-center text-blue-600 text-xl md:text-2xl shadow-md">
              {icon}
            </div>
            <h3 className="text-white text-lg md:text-xl font-bold">
              {title}
            </h3>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="bg-white p-6 md:p-8">
        <p className="text-gray-600 mb-6 line-clamp-3">
          {description}
        </p>
        <Link
          to={link || '#'}
          className="inline-flex items-center text-blue-600 font-medium hover:text-blue-800 transition group"
        >
          Learn More 
          <span className="ml-2 transform group-hover:translate-x-1 transition-transform">→</span>
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;